import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, Search } from 'lib/components';
import styled from 'styled-components/macro';
import { SearchParams } from './types';

const InputWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  .dropdown {
    width: 280px;
  }
`;

interface Props {
  setParams: React.Dispatch<React.SetStateAction<SearchParams>>;
  params: SearchParams;
  typesOptions: {
    value: string;
    label: string;
  }[];
}

export const SearchInputs = ({ setParams, params, typesOptions }: Props) => {
  const { t } = useTranslation();
  const { type, search } = params;
  const setSearchParams = (key: string, value: string) => {
    setParams((state: any) => {
      return {
        ...state,
        [key]: value,
      };
    });
  };

  const defaultValue =
    typesOptions.find(({ value }) => value === type) || typesOptions[0];

  return (
    <InputWrapper>
      <Search
        onSearch={value => setSearchParams('search', value)}
        placeholder={t('Search bin...')}
        width='280px'
        prevSearch={search || ''}
      />
      <Dropdown
        creatable={false}
        onChange={item => setSearchParams('type', item.value)}
        options={typesOptions}
        value={defaultValue}
        placeholder={t('All content types')}
        className='dropdown'
      />
    </InputWrapper>
  );
};
